module.exports = __webpack_public_path__ + "static/img/7.c589406.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/7.png
// module id = YDGr
// module chunks = 1